<template>
<Dialog v-model:visible="show" modal header="Markaya Özel Sütunlar" :style="{ width: '95vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" @hide="resetList">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<ScrollPanel style="width: 100%; height: 500px" v-if="!loading">


<!--
<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newAdded"></ClickAddInputText>
-->
<div class="flex align-items-end justify-content-end ">
<Button type="button" :label="$store.state.languages.lang_phrases.yeni_ekle"  icon="pi pi-plus" class=" p-button-primary p-button-outlined  p-button-sm mt-3" @click="showAddNew"></Button>
</div>



<!-- new item form-->
<div class="grid mt-4" v-if="showaddnew">

<div class="col-12">
<InputText  type="text" v-model="newitem.name" class="w-full p-inputtext-sm animate_class"   :placeholder="$store.state.languages.lang_phrases.isim"/>
</div>

<div class="col-6">
<div class="grid">

<div class="col-4">
<div class="grid">
<div class="col-8"><p><b>Marka ile Paylaş</b></p></div>
<div class="col-4 mt-3"><InputSwitch v-model="newitem.share_with_brand" /></div>
</div>
</div>






</div>
</div>

<div class="col-6">
<div class="grid">
<div class="col-2"><p><b>Tür</b></p></div>
<div class="col-10">
<Dropdown v-model="newitem.columntype" :options="columntypetypes" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm mt-2">
</Dropdown>
</div>

</div>
</div>


<div class="col-12" v-if="newitem.columntype=='select'">
<div class="grid">
<div class="col-12"><h4 class="text-primary">Seçenekler</h4></div>

<div class="col-12">
<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newAddedOption"></ClickAddInputText>
</div>

<div class="col-12">
<div class="grid" v-for="item in newitem.options" >
<div class="col-10">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" :valkey="item.id" @dataChanged="optionNameChanged($event,item.id)" />



</div>

<div class="col-2">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteOption(item.id)"></Button>

</div>
</div>
</div>

</div>


</div>

<div class="col-12">
<div class="flex align-items-end justify-content-end ">

<Button type="button" :label="$store.state.languages.lang_phrases.iptal"  icon="pi pi-times" class=" p-button-danger p-button-outlined  p-button-sm mt-3 mr-2" @click="hideAddNew"></Button>

<Button type="button" :label="$store.state.languages.lang_phrases.kaydet"  icon="pi pi-check" class=" p-button-primary p-button-outlined  p-button-sm mt-3" @click="newAdded"></Button>
</div>
</div>

</div>

<!-- new item form -->
<hr>



<DataTable 
:value="columns" 
class="p-datatable-suppliers" 
:rows="10"
dataKey="id" 
:rowHover="true"
filterDisplay="menu" 
:loading="loading"
editMode="row" 
v-model:editingRows="editingRows"
@row-edit-save="onCellEditComplete"
@row-edit-cancel="cancelRowEdit"
@update:editingRows="goster"
@row-edit-init="startRowEdit"
>

<Column   :header="$store.state.languages.lang_phrases.isim"   field="name" style="width: 20%;">
<template #body="slotProps">
<p>{{ slotProps.data.name}}</p>
</template>
<template #editor="{ data }">
<InputText  type="text" v-model="data.name" class="w-full  p-inputtext-sm animate_class"   />
</template>
</Column>




<Column   :header="$store.state.languages.lang_phrases.tur"   field="columntype">
<template #body="slotProps">
<template v-if="slotProps.data.columntype=='text'">
<Tag 
class="ml-2 mb-2 custom-chip" 
value="Text" 
style="background-color:#3b82f6"
/>
</template>

<template v-if="slotProps.data.columntype=='date'">
<Tag 
class="ml-2 mb-2 custom-chip" 
value="Tarih" 
style="background-color:#7e2f8d"
/>
</template>

<template v-if="slotProps.data.columntype=='select'">
<Tag 
class="ml-2 mb-2 custom-chip" 
value="Seçimli" 
style="background-color:#4dc247"
/>
</template>



</template>
</Column>






<Column   :header="$store.state.languages.lang_phrases.secenekler"   field="options"  style="width: 30%; ">
<template #body="slotProps">
<Tag 
v-for="option in slotProps.data.options"
class="ml-2 mb-2 custom-chip" 
:value="option.name" 
style="background-color:#ff6600"
/>

</template>
<template #editor="{ data,field }">
<ClickAddInputText  
:title="$store.state.languages.lang_phrases.yeni_ekle"  
valkey="new_phrase" 
v-if="data.columntype=='select'"
@newAdded="addNewOption($event,data.id)">
  
</ClickAddInputText>

<div class="grid my-0" v-for="item in editingRowOptions" >



<div class="col-10 my-0">
<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" :valkey="item.id"  @dataChanged="optionNameUpdated($event,data.id)" />


</div>

<div class="col-2 my-0">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteUpdatedOption(item.id,data.id)"></Button>

</div>
</div>


</template>
</Column>








<Column   header="Marka ile Paylaş"   field="share_with_brand " style="width: 12%;">
<template #body="slotProps">
<div class="flex  justify-content-center ">
<p v-html="$filters.booleanView( slotProps.data.share_with_brand)"></p>
</div>
</template>
<template #editor="{ data }">
<div class="flex  justify-content-center ">
<InputSwitch v-model="data.share_with_brand" :trueValue="1" :falseValue="0"/>
</div>
</template>
</Column>


<Column :rowEditor="true" style="width: 6%;" bodyStyle="text-align:center"></Column>

<Column  field="delete " style="width: 6%;">
<template #body="slotProps">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-text   " @click="deleteItem('brand_planner_column',slotProps.data.id)"></Button>
</template>
</Column>



</DataTable>

<!--
<div class="grid" v-for="item in columns" >
<div class="col-10">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged($event,item.id)" />


<ClickEditSwitch  title="Marka ile paylaş" :value="item.share_with_brand" valkey="share_with_brand" @dataChanged="dataChanged($event,item.id)" />

</div>

<div class="col-2">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteItem('brand_planner_column',item.id)"></Button>

</div>
</div>
-->


</ScrollPanel>



</Dialog>


</template>

<script>
import slugify from "slugify"
export default {

  name: 'PlannerSpecificColumnDialog',
  props:["open","brand_id","type"],
  data () {
    return {
      editingRows: [],
      editingRowOptions:[],
    	show:false,
    	loading:true,
    	columns:[],
      display:"list",
      newitem:{
        name:"",
        share_with_brand:false,
        columntype:null,
        options:[],
        customattribute_id:null,
      },
      showaddnew:false,
      columntypetypes:[
      {id:"text",name:"Text"},
      {id:"date",name:"Tarih"},
      {id:"select",name:"Seçimli"},
      ]
    }
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.afternewAdded()
  		}
  	},
  },
  methods:{
    addNewOption(data,column_id)
    {
      let name = data.value
      let slug =  slugify(name, { 
                    replacement: '_',    
                    locale: 'tr',       // language code of the locale to use
                    lower: true, 
                    trim: true         // trim leading and trailing replacement chars, defaults to `true`
                  });
      let new_item = {
        name:name,
        id:slug
      }
      this.editingRowOptions.push(new_item)
    },
    cellEdit(data)
    {
      console.log("cellEdit")
      console.log(data)
    },
    resetList()
    {
      this.editingRows = []
    },
    goster(data)
    {
      
    },
    startRowEdit(data)
    {
      
      this.editingRows = []
      let item = this.columns[data.index]
      this.editingRows.push(item)
      if(item.options && item.options.length && item.columntype=="select")
      {
        this.editingRowOptions = item.options
      }
      else
      {
        this.editingRowOptions = []
      }
      console.log(data)
    },
    optionNameUpdated(data,column_id)
    {      
      let ind = this.editingRowOptions.findIndex(item=>item.id == data.key)
      this.editingRowOptions[ind].name = data.value
    },
    deleteUpdatedOption(data,column_id)
    {      
      this.editingRowOptions = this.editingRowOptions.filter(item=>item.id !== data)
    },
    optionNameChanged(data)
    {
      console.log(data)
      
      let ind = this.newitem.options.findIndex(item=>item.id==data.key)
      let name = data.value
      let slug =  slugify(name, { 
                    replacement: '_',    
                    locale: 'tr',       // language code of the locale to use
                    lower: true, 
                    trim: true         // trim leading and trailing replacement chars, defaults to `true`
                  });
      this.newitem.options[ind].name = name
      this.newitem.options[ind].id = slug
    },
    deleteOption(id)
    {
      this.newitem.options = this.newitem.options.filter(item=>item.id !==id)
    },
    newAddedOption(data)
    {
      console.log(data)
      let name = data.value
      let slug =  slugify(name, { 
                    replacement: '_',    
                    locale: 'tr',       // language code of the locale to use
                    lower: true, 
                    trim: true         // trim leading and trailing replacement chars, defaults to `true`
                  });
      let option = {
        name:name,
        id:slug
      }
      this.newitem.options.push(option)
    },
    showAddNew()
    {
      this.showaddnew = true
    },
    hideAddNew()
    {
      this.showaddnew = false
      this.resetNewItem()
    },
    resetNewItem()
    {
      this.newitem = {
          name:"",
          share_with_brand:false,
          columntype:null,
          options:[],
        }
    },
    onCellEditComplete(data)
    {
      console.log("onCellEditComplete")
      console.log(data)
      console.log(this.editingRowOptions)
      this.columns[data.index] = data.newData
      this.columns[data.index].options = this.editingRowOptions
      this.editingRowOptions = []
      setTimeout(()=>{
        this.updateRowData(data.index)
      })
      
    },
    cancelRowEdit(data)
    {
      console.log("cancelRowEdit")
      console.log(data)
      this.editingRowOptions = []
    },
    updateRowData(index)
    {
      console.log("updateRowData")
      let formdata = new FormData()
      let item = this.columns[index]
      console.log(item)
      formdata.append("item",JSON.stringify(item)) 
      this.generalSubmission(formdata,"update_brand_planner_column/"+item.id,this.afternewAdded)
    },
  	openDialog()
  	{
  		this.show = true
  		this.getData()
  	},
  	async getData()
  	{
  		this.loading = true      
  		this.columns = await this.generalApiGetWithoutLoader("brand_planner_columns/"+this.brand_id+"/"+this.type)
      for(let item of this.columns)
      {
        if(item.options)
        {
          item.options = JSON.parse(item.options)
        }
      }
  		console.log(this.columns)
  		this.loading = false
  	},
  	newAdded()
  	{
      if(this.newitem.name=="")
      {
        this.showMessage("error","Lütfen isim ekleyin")
        return false
      }

      if(!this.newitem.columntype)
      {
        this.showMessage("error","Lütfen bir tür seçin")
        return false
      }

      if(this.newitem.columntype=="select" && !this.newitem.options.length)
      {
        this.showMessage("error","Lütfen seçenek ekleyin")
        return false
      }

  	  let formdata = new FormData()
      formdata.append("item",JSON.stringify(this.newitem))
      formdata.append("type",this.type)    
      this.generalSubmission(formdata,"submit_brand_planner_column/"+this.brand_id,this.afternewAdded)
  	},
  	async afternewAdded(response)
  	{
  		this.columns = await this.generalApiGetWithoutLoader("brand_planner_columns/"+this.brand_id+"/"+this.type)
      for(let item of this.columns)
      {
        if(item.options)
        {
          item.options = JSON.parse(item.options)
        }
      }
      this.hideAddNew()
  		this.$emit("renewData")
  	},
  	dataChanged(data,id)
  	{      
  		let formdata = new FormData()
  		formdata.append(data.key,data.value)
  		this.generalSubmission(formdata,"update_brand_planner_column/"+id,this.afternewAdded)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>